/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TValidatePhoneModel = IModel<IValidatePhoneRequest, TValidatePhoneResponse>;

export interface IValidatePhoneRequest {
  /** Код для подтверждения номера телефона **/
  code?: string | null;
  /** Номер телефона в формате +79991234567 **/
  phone: string;
}

export type TValidatePhoneResponse = IValidatePhoneResponse200 | IValidatePhoneResponse400;

export interface IValidatePhoneResponse200 extends IModelResponse<IValidatePhoneResponse> {
  statusCode: 200;
}

export interface IValidatePhoneResponse400 extends IModelResponse<IValidatePhoneResponseError> {
  statusCode: 400;
}

export interface IValidatePhoneResponse {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number | null;
  /** Статус подтверждения телефона **/
  status: EStatus;
}

export interface IValidatePhoneResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IValidatePhoneResponse | IValidatePhoneResponseError;

export enum EStatus {
  /** Введен неправильный код **/
  Error = 'error',
  /** В процессе проверки **/
  InProgress = 'inProgress',
  /** Проверка успешно завершена **/
  Ok = 'ok',
  /** Проверка пропущена **/
  Skipped = 'skipped',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IValidatePhoneResponse): TResponse200;
  400(response: IValidatePhoneResponseError): TResponse400;
}
